// Tracking constants for calculators
export const HDB_SALES_PROCEEDS_TRACKING = {
  ENTRY_POINT: 'hdb_resale_sales_proceeds',
  PREVIEW: 'hdb_resale_sales_proceeds_preview',
  SHARE: 'hdb_resale_sales_proceeds_share',
} as const;
